<ng-template #modal let-addModal>
  <div class="modal-header">
    <h2 class="modal-title">{{ modalHeader | translate }}</h2>
    <button
      type="button"
      class="close"
      [title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      (click)="hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form [formGroup]="orderTemplateForm" (ngSubmit)="submitOrderTemplateForm()">
    <div class="modal-body">
      <formly-form [form]="orderTemplateForm" [fields]="fields" [model]="model"></formly-form>
    </div>

    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="formDisabled"
        data-testing-id="order-template-dialog-submit"
      >
        {{ primaryButton | translate }}
      </button>
      <button type="button" class="btn btn-secondary" (click)="hide()">
        {{ 'account.cancel.button.label' | translate }}
      </button>
    </div>
  </form>
</ng-template>
